import { combineEpics } from 'redux-observable';
import { loadRegions } from './loadRegions';

export default combineEpics(loadRegions);



// WEBPACK FOOTER //
// ./src/scenes/Regions/services/epics/index.ts